// This file only exists to avoid redifining this function in every single
// file that we convert from coffeescript to javascript. Please do not use
// this function for any other purpose

const hasProp = {}.hasOwnProperty;
const extend = (child, parent) => {
  for (const key in parent) {
    if (hasProp.call(parent, key)) child[key] = parent[key];
  }
  function ctor() {
    this.constructor = child;
  }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
  child.__super__ = parent.prototype;
  return child;
};

module.exports = { extend };
